export enum PositionProcedureExplanationCodeEnum {
    ConsequencesForAnnualBonus = 'Consequences For Annual Bonus',
    ConsequencesForClaimFreeYearsBMLadderAndPremium = 'Consequences For Claim Free Years BM Ladder And Premium',
    RecoverExcess = 'Recover Excess',
    NextStepsIfThereIsCover = 'Next Steps If There Is Cover',
    NextStepsIfThereIsNoCover = 'Next Steps If There Is No Cover',
}
